import { render, staticRenderFns } from "./taskflowConf.vue?vue&type=template&id=7db5d284&scoped=true"
import script from "./taskflowConf.vue?vue&type=script&lang=js"
export * from "./taskflowConf.vue?vue&type=script&lang=js"
import style0 from "./taskflowConf.vue?vue&type=style&index=0&id=7db5d284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5d284",
  null
  
)

export default component.exports